import React, { useState, useEffect, useRef } from 'react';
import './Toggle.css';
import '../Update Email Id/Mailupdate.css'
import { checkwhatsupopt, whatupotptoggle, send_sms, otp_verification, checkonline } from '../../Global/Index';
import { toast } from 'react-toastify';
import { useTheme } from '@mui/material';
import PropTypes from 'prop-types';

const Timer = ({ initialTime, onExpire }) => {
  const [time, setTime] = useState(initialTime);
  const timerRef = useRef(null);

  useEffect(() => {
    timerRef.current = setInterval(() => {
      setTime((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timerRef.current);
          onExpire();
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timerRef.current);
  }, [onExpire]);

  return <p className="timer">{time > 0 ? `OTP will expire in ${time} seconds` : 'OTP has expired'}</p>;
};


const Toggle = ({ mobile_number }) => {
  const [isChecked, setIsChecked] = useState(false);
  const [id, setId] = useState(0);
  const [dataloaded, setDataloaded] = useState(false);
  const [oTP, setOTP] = useState('');
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isResendOtp, setIsResendOtp] = useState(false);
  const [timerKey, setTimerKey] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const ref = React.createRef();
  const theme = useTheme();

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [ref]);


  useEffect(() => {
    checkwhatsupopt().then((data) => {
      if (data.response.status == "200") {
        const newdata = data.response.data;
        setIsChecked(newdata.IsWhatsAppNumber);
        setId(newdata.id)
        setDataloaded(true);
      }
    })
  }, [])




  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setIsOpen(false);
    }
  };


  const handleOtpChange = (e) => {
    setOTP(e.target.value);
  };


  const handleSendOtp = async () => {
    setIsResendOtp(false);
    setIsOtpSent(true);
    setOTP('');
    setTimerKey(prevKey => prevKey + 1);
    try {
      const response = await send_sms(mobile_number);
      console.log(`response of send sms is ${JSON.stringify(response)}`)
    } catch (error) {
      toast.error(error);
    }
  };


  const handleResendOtp = () => {
    handleSendOtp();
  };

  const handlefun = async () => {
    try {
      const customerdetail = {
        "Id": id,
        "IsWhatsAppNumber": !isChecked,
        "mobileNo": mobile_number
      }

      const datas = await whatupotptoggle(customerdetail);
      if (datas.response.status == "500") {
        toast.warn('you are not allowed to perform this operation at this time. Please try again later!')
      } else if (datas.response.status === "503") {
        console.log('no internet connection')
      } else if (datas.response.status == "200") {
        setIsChecked(!isChecked);
        setIsResendOtp(false);
        setIsOtpSent(false);
        setIsOpen(false);
        if (isChecked) {
          toast.success('You will no longer receive regular updates on WhatsApp.')
        } else {
          toast.success('Regular update on whatsApp has been updated successfully.')
        }
      }
    } catch (error) {
      console.log(error)
      toast.error('something went wrong! Please try again later')
    }
  }


  const handleVerifyOtp = async () => {
    try {
      const Mobile_Num = mobile_number;
      const response = await otp_verification({ Mobile_Num, oTP });
      if (response.status === 201) {
        handlefun();
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log(error)
      toast.error("Something went wrong. Please try again later!");
    }
  };

  const handleTimerExpire = () => {
    setIsResendOtp(true);
  };




  const handleToggleup = async () => {
    const res = checkonline();
    if (res) {
      if (isChecked) {
        handleSendOtp();
        setIsOpen(!isOpen);
      } else {
        handlefun()
      }
    }
    else {
      toast.warn("No internet connection. Please connect to the internet .")
    }
  };

  const handleToggleClose = () => {
    setIsOpen(!isOpen);
  }


  const formatMobileNumber = (number) => {
    if (number && number.length >= 4) {
      const lastTwoDigits = number.slice(-4);
      const maskedNumber = 'XXXXXX' + lastTwoDigits;
      return maskedNumber;
    }
    return 'Invalid number';
  };


  if (!dataloaded) {
    return <></>
  }


  return (
    <>
      {dataloaded &&
        <span className="switch-toggle" style={{color:'black'}}>
          <input
            type="checkbox"
            id="bluetooth"
            checked={isChecked}
            onChange={handleToggleup}
          />
          <label
            htmlFor="bluetooth"
            className={isChecked ? 'active' : ''}
            aria-label="Bluetooth option"
          />
        </span>
      }

      {
        dataloaded && isOpen && (
          <div className="emailoutercontainer">
            <div className="email-verification-container" ref={ref} style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.main }} >
              <div style={{ textAlign: 'right', fontSize: '3vh' }}>
                <button
                  type="button"
                  onClick={handleToggleClose}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      handleToggleClose();
                    }
                  }}
                  style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: 'inherit',
                    padding: '0',
                    color: 'inherit'
                  }}
                  aria-label="Close"
                >
                  <i className="bi bi-x-lg" />
                </button>
              </div>

              <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
                An OTP has been sent to your registered mobile number {formatMobileNumber(mobile_number)}.
              </div>

              {isOtpSent && (
                <div>
                  {!isResendOtp && <input maxLength={6} type="tel" className="otp-input" value={oTP} onChange={handleOtpChange} placeholder="Enter OTP" style={{ backgroundColor: theme.palette.primary[900] }} />}
                  {!isResendOtp && <button className="verify-otp-button" onClick={handleVerifyOtp}>
                    Verify OTP
                  </button>}
                  {!isResendOtp && (
                    <Timer key={timerKey} initialTime={120} onExpire={handleTimerExpire} />
                  )}
                  {isResendOtp && (
                    <button className="resend-otp-button" onClick={handleResendOtp}>
                      Resend OTP
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>)
      }
    </>
  );
};

Timer.propTypes = {
  initialTime: PropTypes.number.isRequired, // Required number
  onExpire: PropTypes.func.isRequired,       // Required function
};

Toggle.propTypes = {
  mobile_number: PropTypes.string,

};

export default Toggle;

